export default "__VITE_ASSET__BA1RlNOE__"